import React from 'react'

import packageJson from '../../../package.json'
import { DEPLOYMENT_ENV } from '../../utils/env'

import { FooterContainer, FooterContent, CopyRightLabel } from './styles'

const Footer = () => (
  <FooterContainer>
    <FooterContent>
      <CopyRightLabel>
        © {new Date().getFullYear()} Road Science. All rights reserved.{' '}
        {(DEPLOYMENT_ENV || 'DEV').toUpperCase()} v{packageJson.version}
      </CopyRightLabel>
    </FooterContent>
  </FooterContainer>
)

export { Footer }
